module.exports = _.isString;